// extracted by mini-css-extract-plugin
export default {"advertDetailContactGroup":"c-n_eR","advertDetailContactGroup__header":"c-n_eS","advertDetailContactGroup__value":"c-n_eT"};